module.exports = __webpack_public_path__ + "media/images/badge/genio-264c1fb77f71aed44c78f6a13fb54b7e.png";